import { createModule } from '@vue-storefront/core/lib/module'

const KEY = 'order-history'
export const OrderHistory = createModule({
  key: KEY
})
